<template>
  <div id="climbostatics" style="padding-top:54px; height: calc(100vh - 64px); overflow:scroll; padding-bottom:10px;">

    <div>

    <md-tabs id="staticTenduTab" md-centered class="md-accent" :md-navigation="tabNav" ref="statsNav" :md-dynamic-height="tabNav" style="margin-bottom:48px;">
      <md-tab id="alles" md-label="Alles">
        <md-list style="max-width: 360px; margin:auto;">

          <md-list-item style="padding-bottom:20px; margin-top:30px;">
            <md-whiteframe md-elevation="1" style="width:100%; height:200px; position:relative;">
              <div class="UIAAuser md-title">UIAA</div>
              <apexchart id="apexUser" ref="totalRef" width="100%" height="210" type="bar" :options="totalBarOptions" :series="totalSeries"></apexchart>
            </md-whiteframe>

          </md-list-item>

          <span v-if="cutOffDate > 0" class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit {{ cutOffDate | localdate }}</strong></span>
          <span v-else class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit Beginn Routenbuch</strong></span>

          <md-list-item style="padding-bottom:20px;" v-if="totalKPI">
            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span class="md-display-1">{{ totalKPI.numberOfClimbs }}</span>
              <div class="md-body-1">Anzahl</div>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!totalKPI.avgDifficulty" class="md-display-1">0</span>
              <span v-else class="md-display-1">{{ totalKPI.avgDifficulty }}</span>
              <div class="md-body-1">Durchschnitt</div><br>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!totalKPI.maxDifficulty" class="md-display-1" style="text-align:center;">0</span>
              <span v-else class="md-display-1" style="text-align:center;">{{ totalKPI.maxDifficulty }}</span>
              <div class="md-body-1">max.</div>
            </md-whiteframe>
          </md-list-item>
          <!-- <div style="margin-right: 6px; text-align:right;">
            <md-button class="md-raised md-primary" @click="changeTimePeriod('all'), getUserKPI()">Update
            </md-button>
          </div> -->
        </md-list>
      </md-tab>

      <md-tab id="onsight" md-label="Onsight">
        <md-list style="max-width: 360px; margin:auto;">
          <md-list-item style="padding-bottom:20px;">
            <md-whiteframe md-elevation="1" style="width:100%; margin-top:20px; height:200px; position:relative;">
              <div class="UIAAuser md-title">UIAA</div>
              <apexchart ref="onsightRef" id="apexUser" width="100%" height="210" type="bar" :options="onsightBarOptions" :series="onsightSeries"></apexchart>
            </md-whiteframe>
          </md-list-item>

          <span v-if="cutOffDate > 0" class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit {{ cutOffDate | localdate }}</strong></span>
          <span v-else class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit Beginn Routenbuch</strong></span>

          <md-list-item style="padding-bottom:20px;" v-if="onsightKPI">
            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span class="md-display-1">{{ onsightKPI.numberOfClimbs }}</span>
              <div class="md-body-1">Anzahl</div>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!onsightKPI.avgDifficulty" class="md-display-1">0</span>
              <span v-else class="md-display-1">{{ onsightKPI.avgDifficulty }}</span>
              <div class="md-body-1">Durchschnitt</div><br>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!onsightKPI.maxDifficulty" class="md-display-1" style="text-align:center;">0</span>
              <span v-else class="md-display-1" style="text-align:center;">{{ onsightKPI.maxDifficulty }}</span>
              <div class="md-body-1">max.</div>
            </md-whiteframe>
          </md-list-item>


        </md-list>

      </md-tab>


      <md-tab id="flash" md-label="Flash">
        <md-list style="max-width: 360px; margin:auto;">
          <md-list-item style="padding-bottom:20px;">
            <md-whiteframe md-elevation="1" style="width:100%; margin-top:20px; height:200px; position:relative;">
              <div class="UIAAuser md-title">UIAA</div>
              <apexchart id="apexUser" width="100%" height="210" type="bar" :options="flashBarOptions" :series="flashSeries"></apexchart>
            </md-whiteframe>
          </md-list-item>

          <span v-if="cutOffDate > 0" class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit {{ cutOffDate | localdate }}</strong></span>
          <span v-else class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit Beginn Routenbuch</strong></span>

          <md-list-item style="padding-bottom:20px;" v-if="flashKPI">
            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span class="md-display-1">{{ flashKPI.numberOfClimbs }}</span>
              <div class="md-body-1">Anzahl</div>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!flashKPI.avgDifficulty" class="md-display-1">0</span>
              <span v-else class="md-display-1">{{ flashKPI.avgDifficulty }}</span>
              <div class="md-body-1">Durchschnitt</div><br>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!flashKPI.maxDifficulty" class="md-display-1" style="text-align:center;">0</span>
              <span v-else class="md-display-1" style="text-align:center;">{{ flashKPI.maxDifficulty }}</span>
              <div class="md-body-1">max.</div>
            </md-whiteframe>
          </md-list-item>

        </md-list>
      </md-tab>

      <md-tab id="redpoint" md-label="Rotpunkt">
        <md-list style="max-width: 360px; margin:auto;">
          <md-list-item style="padding-bottom:20px;">
            <md-whiteframe md-elevation="1" style="width:100%; margin-top:20px; height:200px; position:relative;">
              <div class="UIAAuser md-title">UIAA</div>
              <apexchart id="apexUser" width="100%" height="210" type="bar" :options="redpointBarOptions" :series="redpointSeries"></apexchart>
            </md-whiteframe>
          </md-list-item>

          <span v-if="cutOffDate > 0" class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit {{ cutOffDate | localdate }}</strong></span>
          <span v-else class="md-caption" style="color: #c51162; padding-left:16px; padding-bottom:10px;"><strong>Routen geklettert seit Beginn Routenbuch</strong></span>

          <md-list-item style="padding-bottom:20px;" v-if="redpointKPI">
            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span class="md-display-1">{{ redpointKPI.numberOfClimbs }}</span>
              <div class="md-body-1">Anzahl</div>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!redpointKPI.avgDifficulty" class="md-display-1">0</span>
              <span v-else class="md-display-1">{{ redpointKPI.avgDifficulty }}</span>
              <div class="md-body-1">Durchschnitt</div><br>
            </md-whiteframe>

            <md-whiteframe md-elevation="1" style="width:95px; height:80px; padding:8px;">
              <span v-if="!redpointKPI.maxDifficulty" class="md-display-1" style="text-align:center;">0</span>
              <span v-else class="md-display-1" style="text-align:center;">{{ redpointKPI.maxDifficulty }}</span>
              <div class="md-body-1">max.</div>
            </md-whiteframe>
          </md-list-item>

        </md-list>
      </md-tab>

    </md-tabs>


  </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'ClimboStatics',

  data () {
    return {
      tabNav:false,
    }
  },

  methods: {
    ...mapMutations([
      'changeTimePeriod'
    ]),

    getUserKPI () {
      var userKPILink = this.userPrivileges.links.climbingKPI
      this.$store.dispatch('gettingUserKPI', userKPILink)
    },

  },

  computed: {
    ...mapState([
      'validUser',
      'profileMail',
      'userPrivileges',
      'totalKPI',
      'onsightKPI',
      'flashKPI',
      'redpointKPI',
      'sectorStats',
      'cutOffDate',
      'totalBarOptions',
      'totalSeries',
      'onsightBarOptions',
      'onsightSeries',
      'flashBarOptions',
      'flashSeries',
      'redpointBarOptions',
      'redpointSeries',
    ]),

    totalMaxBar () {
      return this.$store.state.totalBarOptions.yaxis.max
    },
    onsightMaxBar () {
      return this.$store.state.onsightBarOptions.yaxis.max
    },
    flashMaxBar () {
      return this.$store.state.flashBarOptions.yaxis.max
    },
    redpointMaxBar () {
      return this.$store.state.redpointBarOptions.yaxis.max
    },
  }
}

</script>

<style>

  g line:g:nth-child(1) {
    display:none;
  }

  g {
    font-style: normal;
    font-size:11px;
  }
  .apexcharts-tooltip {
    background: #ffffff;
    color: grey;
    border:none;
    border-radius:none;
  }
  .md-theme-default.md-tabs.md-accent>.md-tabs-navigation {
    border-bottom:none !important;
    position:fixed;
    width:100%;
    bottom:0px;
    overflow: hidden;
  }

  #apexUser {
    padding-left:25px;
    padding-right:0px;
    max-width: 720px;
    margin-top:-30px;
    margin-left:auto;
    margin-right:auto;
    position:relative;
    z-index:12;
  }

  .UIAAuser {
    text-align:left;
    z-index:11;
    position:relative;
    top:128px;
    left:0px;
    height:30px;
    color:rgb(0, 131, 143,0.7);
    background-color:#ffffff;
    width:50px;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
  }

</style>
